import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import { usePillarTableFilterState } from "shared/components/pillar-table/filters/hooks/usePillarTableFilterState";
import PillarTableFilterLabel from "shared/components/pillar-table/filters/PillarTableFilterLabel";

type PillarTableFilterSingleDateProps = Omit<
  ComponentPropsWithoutRef<"input">,
  "value" | "name" | "onChange" | "type" | "title"
> & {
  title: string;
  filterKey: string;
  toolTip?: ReactNode;
};

const PillarTableFilterSingleDate = ({
  filterKey,
  title,
  toolTip,
  ...props
}: PillarTableFilterSingleDateProps) => {
  const { setFilterValue, filterValue } = usePillarTableFilterState<string>({
    filterKey,
    defaultValue: props.defaultValue?.toString(),
  });

  return (
    <div className="flex flex-col">
      <PillarTableFilterLabel
        className="text-neutral-mid-600"
        htmlFor={`filter-single-date-${filterKey}`}
        filterKey={filterKey}
        title={title}
        toolTip={toolTip}
      />
      <input
        value={filterValue}
        name={`filter-single-date-${filterKey}`}
        title={title}
        onChange={(e) => {
          setFilterValue(e.target.value);
        }}
        type="date"
        className="!rounded !border-neutral-mid-200 !text-neutral-mid-600 !font-medium"
        {...props}
      />
    </div>
  );
};

export default PillarTableFilterSingleDate;
